import React, { useEffect, useState } from "react";
import Button from "../../../components/common/ui/Button";
import {
  DateInput,
  SelectInput,
  TextInput,
} from "../../../components/common/ui/Inputs";
import { useDispatch, useSelector } from "react-redux";
import { inmateAction, masterActions } from "../../../_store";
import { useLocation } from "react-router-dom";
import { fDate, MinDate, Today } from "../../../utils/formatTime";
import generateMessagePDF from "../../../components/common/export/Reports/generateMessagePDF";
import CustomLoader from "../../../components/common/ui/Loader";
import loaddataimg from "../../../assets/svg/load-data.svg";
import generateNewInmateMessagePDF from "../../../components/common/export/Reports/generateNewInmateMessagePDF";

const Messages = ({ loadData, render }) => {
  const location = useLocation();
  const { inmate: Inmate } = location.state || {};

  const { direction } = useSelector((x) => x.dropdownOptions);
  const {
    inmateInfoTabData,
    messageConversationdata,
    messaageConversationHeader,
    loading,
    inmate,
  } = useSelector((x) => x.inmate);

  const { commonFacilityCode } = useSelector((x) => x.auth);
  const { loading: masterLoading } = useSelector((x) => x.master);

  useEffect(() => {
    setAllowDownload(loadData);
    setMessages({
      FacilityID:
        Inmate?.facilityID || inmate?.facilityID || commonFacilityCode,
      InmatesId: Inmate?.InmateID || inmate?.InmateID,
      NoticesTitle: "",
      MenuName: "",
      UserFirstName: "",
      UserLastName: "",
      UserFirstNameId: 0,
      UserLastNameId: 0,
      MessageDirection: 0,
      MessageFlag: 3,
      MessageSendStartDate: "",
      MessageSendEndDate: "",
    });
  }, [render]);

  const { publicUserLastName, publicUserFirstName, facilityDropDown } =
    useSelector((x) => x.master);

  const [allowDownload, setAllowDownload] = useState(loadData);
  const [disable, setDisable] = useState(false);
  const [conversationFilterBy, setconversationFilterBy] = useState("DateRange");
  const [errors, setErrors] = useState({});

  const dispatch = useDispatch();

  useEffect(() => {
    if (messageConversationdata?.length > 0) {
      setDisable(true);
    } else {
      setDisable(false);
    }
  }, [messageConversationdata]);

  //Bind the Public UserNames for dropdown
  useEffect(() => {
    if (!Inmate?.InmateID && !inmate?.InmateID) return;

    const facilityID =
      Inmate?.facilityID || inmate?.facilityID || commonFacilityCode;
    const inmateID = Inmate?.InmateID || inmate?.InmateID;
    const firstName = Inmate?.FirstName || inmate?.FirstName;
    const lastName = Inmate?.LastName || inmate?.LastName;

    // Dispatch actions for public last name and first name
    dispatch(
      masterActions.GetPublicLastName({
        facilityID,
        firstName: "", // As per the existing logic, leaving firstName as empty string
        inmatesId: inmateID,
      })
    );

    dispatch(
      masterActions.GetPublicFirstName({
        facilityID,
        lastName: "", // As per the existing logic, leaving lastName as empty string
        inmatesId: inmateID,
      })
    );

    setMessages({
      ...messages,
      FacilityID: facilityID,
      InmatesId: inmateID,
      NoticesTitle: firstName,
      MenuName: lastName,
    });
  }, [Inmate || inmate]);

  // const FacilityName = facilityDropDown?.find(
  // (item) => item?.value === parseInt(commonFacilityCode)
  // )?.label;

  const [messages, setMessages] = useState({
    FacilityID: Inmate?.facilityID || inmate?.facilityID || commonFacilityCode,
    InmatesId: 0,
    NoticesTitle: "",
    MenuName: "",
    UserFirstName: "",
    UserLastName: "",
    UserFirstNameId: 0,
    UserLastNameId: 0,
    MessageDirection: 0,
    MessageFlag: 3,
    MessageSendStartDate: "",
    MessageSendEndDate: "",
  });

  let updatedSearch = { ...messages };

  const handleSelectChange = (selectedOption, name) => {
    const handleFirstName = () => {
      updatedSearch[name] =
        selectedOption?.value > 0 ? selectedOption?.label : "";
      updatedSearch.UserFirstNameId = selectedOption?.value || 0;
      // updatedSearch.NoticesTitle =
      //   selectedOption?.value > 0 ? selectedOption?.label : "";
    };

    const handleLastName = () => {
      updatedSearch[name] =
        selectedOption?.value > 0 ? selectedOption?.label : "";
      updatedSearch.UserLastNameId = selectedOption?.value || 0;

      // updatedSearch.MenuName =
      //   selectedOption?.value > 0 ? selectedOption?.label : "";

      updatedSearch.UserFirstName = "";
      updatedSearch.UserFirstNameId = 0;

      dispatch(
        masterActions.GetPublicFirstName({
          facilityID: updatedSearch.FacilityID,
          lastName: updatedSearch.UserLastName,
          inmatesId: updatedSearch.InmatesId,
        })
      );
    };

    switch (name) {
      case "UserLastName":
        handleLastName();
        break;

      case "UserFirstName":
        handleFirstName();
        break;

      default:
        updatedSearch[name] = selectedOption?.value;
        break;
    }

    setMessages(updatedSearch);

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  // const handleDateChange = (value, name) => {
  //   const date = fDate(value);
  //   updatedSearch[name] = date;
  //   // if (
  //   //   name === "MessageSendStartDate" &&
  //   //   new Date(date) > new Date(messages.MessageSendEndDate)
  //   // ) {
  //   //   updatedSearch.MessageSendEndDate = ""; // Reset ToDate if FromDate is greater
  //   // }
  //   setMessages(updatedSearch);
  // };
  const handleDateChange = (value, name) => {
    const date = fDate(value);

    let updatedSearch = { ...messages };

    updatedSearch[name] = date;

    if (name === "MessageSendStartDate" && messages.MessageSendEndDate) {
      const start = new Date(date);
      const end = new Date(messages.MessageSendEndDate);

      const sixMonthsLater = new Date(start);
      sixMonthsLater.setMonth(start.getMonth() + 12);

      if (end > sixMonthsLater) {
        updatedSearch.MessageSendEndDate = fDate(
          sixMonthsLater <= new Date()
            ? sixMonthsLater
            : new Date()
        );
      }
    }

    if (name === "MessageSendEndDate" && messages.MessageSendStartDate) {
      const start = new Date(messages.MessageSendStartDate);
      const end = new Date(date);

      const sixMonthsEarlier = new Date(end);
      sixMonthsEarlier.setMonth(end.getMonth() - 12);

      if (start < sixMonthsEarlier) {
        updatedSearch.MessageSendStartDate = fDate(sixMonthsEarlier);
      }
    }

    setMessages(updatedSearch);
  };

  const handleDateEnterKey = (event, name) => {
    if (event.key === "Enter" && updatedSearch[name] === "") {
      const currentDate = new Date();

      // Set today's date using the same logic as your handleDateChange
      handleDateChange(currentDate, name);
    }

    const regex = /^[0-9/]$/; // Allow numbers and "/"

    if (
      !regex.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      !(event.ctrlKey && event.key === "v")
    ) {
      event.preventDefault();
    }

    // Auto-insert '/' when typing
    const input = event.target.value;

    if (event.key !== "Backspace" && event.key !== "Delete") {
      if (input?.length === 2 || input?.length === 5) {
        event.target.value = input + "/";
      }
    }
  };

  const handleDateBlur = (e, fieldName) => {
    const value = e.target.value;

    const minDate = MinDate();
    const today = Today();

    if (!value) return;

    let updatedStartDate = messages.MessageSendStartDate;
    let updatedEndDate = messages.MessageSendEndDate;

    const inputDate = new Date(value);

    const isValidDate = inputDate >= minDate && inputDate <= today;

    if (!isValidDate) return;

    if (fieldName === "MessageSendStartDate") {
      updatedStartDate = fDate(value);

      if (updatedEndDate) {
        const start = new Date(updatedStartDate);

        const sixMonthsLater = new Date(start);
        sixMonthsLater.setMonth(start.getMonth() + 12);

        if (new Date(updatedEndDate) > sixMonthsLater) {
          updatedEndDate = fDate(
            sixMonthsLater <= today ? sixMonthsLater : today
          );
        }
      }
    }

    if (fieldName === "MessageSendEndDate") {
      updatedEndDate = fDate(value);

      if (updatedStartDate) {
        const end = new Date(updatedEndDate);

        const sixMonthsEarlier = new Date(end);
        sixMonthsEarlier.setMonth(end.getMonth() - 12);

        if (new Date(updatedStartDate) < sixMonthsEarlier) {
          updatedStartDate = fDate(
            sixMonthsEarlier >= minDate ? sixMonthsEarlier : minDate
          );
        }
      }
    }

    setMessages({
      ...messages,
      MessageSendStartDate: updatedStartDate,
      MessageSendEndDate: updatedEndDate,
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    let newErrors = {
      UserLastName: "",
      UserFirstName: "",
      MessageSendStartDate: "",
      MessageSendEndDate: "",
    };

    // ✅ Username filter validation
    if (conversationFilterBy === "UserName") {
      if (!messages?.UserLastNameId || messages.UserLastNameId === 0) {
        newErrors.UserLastName = "Please Select Public User Last Name";
      }

      if (!messages?.UserFirstNameId || messages.UserFirstNameId === 0) {
        newErrors.UserFirstName = "Please Select Public User First Name";
      }
    }

    // ✅ DateRange filter validation
    if (conversationFilterBy === "DateRange") {
      if (!messages?.MessageSendStartDate) {
        newErrors.MessageSendStartDate = "Please Select From Date";
      }

      if (!messages?.MessageSendEndDate) {
        newErrors.MessageSendEndDate = "Please Select To Date";
      }
      setAllowDownload(false);
    }

    setErrors(newErrors);

    // ✅ Stop submit if any validation exists
    if (
      newErrors.UserLastName ||
      newErrors.UserFirstName ||
      newErrors.MessageSendStartDate ||
      newErrors.MessageSendEndDate
    ) {
      return;
    }

    let param = {
      FacilityID: messages?.FacilityID,
      InmatesId: messages?.InmatesId,
      NoticesTitle: messages?.NoticesTitle,
      MenuName: messages?.MenuName,
      UserFirstName: "",
      UserLastName: "",
      MessageDirection: 0,
      MessageFlag: 3,
      MessageSendStartDate: messages.MessageSendStartDate || "",
      MessageSendEndDate: messages.MessageSendEndDate || "",
    };

    dispatch(inmateAction.MessageConversationInmateHeader(param));

    setAllowDownload(true);

    dispatch(inmateAction.MessageConversationInmate(messages));
  };

  const handleCancel = (e) => {
    e.preventDefault();
    setAllowDownload(false);
    setDisable(false);
    dispatch(inmateAction.clearMessageConversation());
  };

  const handleDownload = (e) => {
    e.preventDefault();

    const title = "Message Conversation";

    const messageConversation = messageConversationdata?.map((obj) => ({
      Sender: obj?.Sender || "         N/A         ",
      MessageSentDate: obj?.MessageSentDate || "         N/A         ",
      ReceiverRead: obj?.ReceiverRead || "         N/A         ",
      MessageSubject: obj?.MessageSubject || "         N/A         ",
      MessageBody: obj?.MessageBody || "         N/A         ",
      PublicUser: obj?.PublicUser || "         N/A         ",
      MessageReceiveDate: obj?.MessageReceiveDate || "         N/A         ",
    }));
    const facilityName = messaageConversationHeader[0]?.FacilityName;
    const inmateName = messaageConversationHeader[0]?.InmateFullName;
    const inmateId = messaageConversationHeader[0]?.InmateResidentId;
    const date =
      messaageConversationHeader[0]?.FromDate &&
      `${fDate(messaageConversationHeader[0]?.FromDate) || "-"} - ${fDate(messaageConversationHeader[0]?.ToDate) || "-"
      }`;

    // generateMessagePDF(
    //   facilityName,
    //   inmateName,
    //   inmateId,
    //   date,
    //   messageConversation,
    //   title
    // );
    generateNewInmateMessagePDF(
      facilityName,
      inmateName,
      inmateId,
      date,
      messageConversation,
      title
    );

    setAllowDownload(false);
    setDisable(false);
    dispatch(inmateAction.clearMessageConversation());
  };

  const handleFilterChange = (value) => {
    setconversationFilterBy(value);

    if (value === "UserName") {
      setMessages((prev) => ({
        ...prev,
        MessageSendStartDate: "",
        MessageSendEndDate: "",
        MessageDirection: 0,
      }));
      setErrors({
        ...errors,
        UserLastName: "",
        UserFirstName: "",
        MessageSendStartDate: "",
        MessageSendEndDate: "",
      });
    }

    if (value === "DateRange") {
      setMessages((prev) => ({
        ...prev,
        UserFirstNameId: null,
        UserLastNameId: null,
      }));
      setErrors({
        ...errors,
        UserLastName: "",
        UserFirstName: "",
        MessageSendStartDate: "",
        MessageSendEndDate: "",
      });
    }
  };

  if (loading || masterLoading) {
    return <CustomLoader />;
  }

  return (
    <>
      <div className="d-none" id="output"></div>
      <div className="d-none" id="outputBody"></div>
      <div className="p-2 w-100">
        <h4 className="inner-header-bg text-color">
          {" "}
          <i className="fa-solid fa-filter me-2"></i>Filter{" "}
        </h4>
        <form onSubmit={(e) => handleSubmit(e)}>
          <div className="row">
            <div className="p-2 m-1 d-flex flex-wrap align-items-center mb-4">
              <div className="col-sm-12 col-md-4">
                <label className="fs-5">Inmate Last Name :</label>
                <strong className="fs-5 text-end mx-2">
                  {Inmate?.LastName ||
                    inmate?.LastName ||
                    (inmateInfoTabData?.length > 0 &&
                      inmateInfoTabData[0]?.LastName)}
                </strong>
              </div>

              <div className="col-sm-12 col-md-4 ">
                <label className="fs-5">Inmate First Name :</label>
                <strong className="fs-5 text-end mx-2">
                  {Inmate?.FirstName ||
                    inmate?.FirstName ||
                    (inmateInfoTabData?.length > 0 &&
                      inmateInfoTabData[0]?.FirstName)}
                </strong>
              </div>

              <div className="col-md-4 col-sm-12 d-flex align-items-center">
                <label className="fs-5 me-2">
                  Sort By :
                </label>

                <div className="fs-5">

                  <label className="me-3">
                    <input
                      type="radio"
                      name="filterBy"
                      value="DateRange"
                      checked={conversationFilterBy === "DateRange"}
                      disabled={messageConversationdata?.length > 0 && allowDownload && conversationFilterBy === "UserName"}
                      onChange={(e) => handleFilterChange(e.target.value)}
                    />
                    {" "}Date Range
                  </label>

                  <label className="ms-2">
                    <input
                      type="radio"
                      name="filterBy"
                      value="UserName"
                      checked={conversationFilterBy === "UserName"}
                      disabled={messageConversationdata?.length > 0 && allowDownload && conversationFilterBy === "DateRange"}
                      onChange={(e) => handleFilterChange(e.target.value)}
                    />
                    {" "}User Name
                  </label>

                </div>
              </div>

            </div>
          </div>

          <div className="row mb-3">
            {/* Second Row: Email, State, City */}

            <div className="col-lg-4 col-md-6 col-sm-6">
              <div className="form-floating mb-3">
                {/* State */}
                <SelectInput
                  options={publicUserLastName}
                  value={messages?.UserLastNameId}
                  handleChange={(selectedOption) =>
                    handleSelectChange(selectedOption, "UserLastName")
                  }
                  isMulti={false}
                  closeMenuOnSelect={true}
                  isDisabled={disable}
                  isLoading={false}
                  isClearable={messages?.UserLastNameId ? true : false}
                  placeholder="Select LastName"
                  label="Public User Last Name"
                  required={conversationFilterBy === "UserName"}
                  errorMessage={errors.UserLastName}
                />
                {errors.UserLastName && (
                  <div className="text-danger fw-700 fs-6">
                    {errors.UserLastName}
                  </div>
                )}
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-6">
              <div className="form-floating mb-3">
                {/* State */}
                <SelectInput
                  options={publicUserFirstName}
                  value={messages?.UserFirstNameId}
                  handleChange={(selectedOption) =>
                    handleSelectChange(selectedOption, "UserFirstName")
                  }
                  isMulti={false}
                  closeMenuOnSelect={true}
                  isDisabled={disable}
                  isLoading={false}
                  isClearable={messages?.UserFirstNameId ? true : false}
                  placeholder="Select State"
                  label="Public User First Name"
                  required={conversationFilterBy === "UserName"}
                  errorMessage={errors.UserFirstName}
                />
                {errors.UserFirstName && (
                  <div className="text-danger fw-700 fs-6">
                    {errors.UserFirstName}
                  </div>
                )}
              </div>
            </div>

            {/* Third Row: Phone Number, From Date, To Date */}

            <div className="col-lg-4 col-md-6 col-sm-6">
              <div className="form-floating mb-3">
                <DateInput
                  value={messages.MessageSendStartDate}
                  handleChange={(e) =>
                    handleDateChange(e, "MessageSendStartDate")
                  }
                  name="MessageSendStartDate"
                  label={"From Date"}
                  // maxDate={
                  //   messages.MessageSendEndDate
                  //     ? messages.MessageSendEndDate
                  //     : new Date()
                  // }
                  maxDate={
                    messages.MessageSendEndDate
                      ? messages.MessageSendEndDate
                      : new Date()
                  }
                  //required={false}
                  required={conversationFilterBy === "DateRange"}
                  disabled={disable || conversationFilterBy === "UserName"}
                  yearDropDown={false}
                  monthDropDown={false}
                  className={false ? "disabled-date-input" : ""} // Add class conditionally
                  isClearable={messages.MessageSendStartDate}
                  preventClear={!messages.MessageSendStartDate}
                  minDate={new Date(2017, 0, 1)}
                  handleBlur={(e) => handleDateBlur(e, "MessageSendStartDate")}
                  handleKeyDown={(e) =>
                    handleDateEnterKey(e, "MessageSendStartDate")
                  }
                  errorMessage={messages.MessageSendStartDate ? {} : errors}
                >
                </DateInput>
                {/* {errors.MessageSendStartDate && (
                  <div className="text-danger fw-700 fs-6">
                    {errors.MessageSendStartDate}
                  </div>
                )} */}
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-6">
              <div className="form-floating mb-3">
                <DateInput
                  value={messages.MessageSendEndDate}
                  handleChange={(e) =>
                    handleDateChange(e, "MessageSendEndDate")
                  }
                  name="MessageSendEndDate"
                  minDate={
                    messages.MessageSendStartDate
                      ? messages.MessageSendStartDate
                      : new Date(2017, 0, 1)
                  }
                  label={"To Date"}
                  // maxDate={new Date()}
                  maxDate={
                    messages.MessageSendStartDate
                      ? new Date(
                        Math.min(
                          new Date(messages.MessageSendStartDate).setMonth(
                            new Date(messages.MessageSendStartDate).getMonth() + 12
                          ),
                          new Date()
                        )
                      )
                      : new Date()
                  }
                  //required={false}
                  required={conversationFilterBy === "DateRange"}
                  disabled={disable || conversationFilterBy === "UserName"}
                  yearDropDown={false}
                  monthDropDown={false}
                  isClearable={messages.MessageSendEndDate}
                  preventClear={!messages.MessageSendEndDate}
                  handleBlur={(e) => handleDateBlur(e, "MessageSendEndDate")}
                  handleKeyDown={(e) =>
                    handleDateEnterKey(e, "MessageSendEndDate")
                  }
                  errorMessage={messages.MessageSendEndDate ? {} : errors}
                >
                </DateInput>
                {/* {errors.MessageSendEndDate && (
                  <div className="text-danger fw-700 fs-6">
                    {errors.MessageSendEndDate}
                  </div>
                )} */}
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-6">
              <div className="form-floating mb-3">
                {/* Status */}
                <SelectInput
                  options={direction}
                  value={messages?.MessageDirection} // This is the selected value (e.g., 0, 1)
                  handleChange={(selectedOption) =>
                    handleSelectChange(selectedOption, "MessageDirection")
                  }
                  isClearable={messages?.MessageDirection ? true : false}
                  isMulti={false}
                  closeMenuOnSelect={true}
                  isDisabled={disable || conversationFilterBy === "UserName"}
                  isLoading={false}
                  placeholder="Select Direction"
                  label={"Direction"}
                />
              </div>
            </div>

            {/* Fourth Row: Connection, Status */}
          </div>

          <div className="mt-3 d-flex flex-wrap gap-3">
            {(messageConversationdata && messageConversationdata?.length > 0 && allowDownload) ? (
              <div className="d-flex flex-wrap align-items-start">
                <label className="fs-5 fw-bold" style={{ color: "#009759" }}>
                  Data loaded successfully. Click download button to export
                  PDF.
                </label>
              </div>
            ) :
              (messageConversationdata && messageConversationdata?.length === 0 && allowDownload) ? (
                <div className="d-flex flex-wrap align-items-start">
                  <label className="fs-5 fw-bold text-danger">
                    No Data Available
                  </label>
                </div>
              )
                : (conversationFilterBy === "DateRange") ?
                  <p className="fst-italic font-bold">
                    Note : You can select a date range of up to one year only.
                  </p>
                  : ""}

            <div className="d-flex flex-wrap ms-auto">
              {messageConversationdata?.length === 0 && (
                <Button
                  className="me-2"
                  label={"LOAD DATA"}
                  type={"submit"}
                  status={"btn-label"}
                  imgsrc={loaddataimg}
                  disabled={false}
                ></Button>
              )}
              {messageConversationdata?.length > 0 && allowDownload && (
                <>
                  <Button
                    className="me-2"
                    label={"CANCEL"}
                    type={"submit"}
                    icon={"fa-solid fa-xmark"}
                    variant="danger"
                    status={"primary"}
                    disabled={false}
                    onClick={handleCancel}
                  />
                  <Button
                    className="me-2"
                    label={"Download"}
                    type={"button"}
                    status={"success"}
                    icon={"fa-solid fa-download"}
                    disabled={false}
                    onClick={(e) => handleDownload(e)}
                  ></Button>
                </>
              )}
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default React.memo(Messages);
